module.exports = __webpack_public_path__ + "static/img/banner-bg.bb055ab0.jpg";